import type { DynamoDbCarDetails } from '@ourbranch/schema-types/dynamodb';
import { isPotentialCommercialVehicle } from '@ourbranch/lookups';

import { defineInternalTask } from '../../../config/types';
import { internalTasks, reviewTeams } from '../../../config/constants';

import { baseBindState, formatCarData } from './lib/helpers';

export const potentialCommercialVehicle = defineInternalTask({
  taskName: internalTasks.PotentialCommercialVehicle,
  config: {
    staffDisplayName: 'Potential Commercial Vehicle: verification needed',
    reviewTeam: reviewTeams.uwOps,
    policyTypes: ['A'],
    enabled: true,
    trigger: ({ policy, offer }) => {
      const cars = (offer?.quote?.cars || []).filter((c): c is DynamoDbCarDetails => !!c);
      const commercialCars = cars.filter((car) =>
        isPotentialCommercialVehicle(car.make || null, car.model || null, car.primaryUse || null)
      );
      if (commercialCars.length === 0) {
        return null;
      }
      return {
        data: { carsData: formatCarData(commercialCars) },
        bindState: baseBindState(policy)
      };
    },
    description: ({ policyId, data }) =>
      `Please review the following car(s) on ${policyId} for potential commercial use:
${data.carsData || 'N/A'}`
  }
});
